// 获取url参数
export const GetQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r;
  if (window.location.search == '') {
    if (window.location.hash != "" && window.location.hash != "#/") {
      r = window.location.hash.split("?")[1].match(reg);
    }
  } else {
    r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  }
  // console.log(r)
  var context = "";
  if (r != null) context = decodeURIComponent(r[2]);
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined"
    ? ""
    : context;
};
// 判断平台
export const judgePlateFrom = () => {
  if (/AlipayClient/.test(window.navigator.userAgent)) {
    //判断是否是支付宝浏览器打开
    console.log("支付宝客户端");
    return "alipay";
  }

  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    console.log("微信浏览器");
    return "wechat";
  }

  return "undefined";
};

// 判断平台-电脑环境
export const isDesktopEnvironment = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent;

  // 检测移动设备
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|tablet|Tablet/i.test(userAgent);

  // 检测平板设备（iPad在较新系统中UA可能不含"Mobile"）
  const isTablet = /(iPad|tablet)/i.test(userAgent) ||
    (navigator.maxTouchPoints > 2 && navigator.maxTouchPoints < 9 && window.innerWidth > 768);

  // 桌面环境：不是移动设备，不是平板，并且屏幕宽度足够大
  return !isMobile && !isTablet ;
}

// 判断平台
export const isWechat = () => {
  //是否是微信浏览器
  if (/(micromessenger)/i.test(navigator.userAgent)) {
    //是否电脑微信或者微信开发者工具
    if (/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)) {
      return true;
    } else {
      //手机微信打开的浏览器
      return true;
    }
  } else {
    return false;
  }
};

// 判断是否微信小程序环境
export const isWeChatMiniProgram = () => {
  if (typeof wx !== 'undefined' && typeof wx.getSystemInfo === 'function') {
    return true;
  }
  if (typeof uni !== 'undefined' && uni.getSystemInfoSync) {
    return uni.getSystemInfoSync().platform === 'wechat';
  }
  return false;
}


// 判断是否ios机型
export const checkDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/iPhone|iPad|iPod/i.test(userAgent) && !window.MSStream) {
    return true;
  } else {
    return false;
  }
}

// 判断是否webapp
export const isInStandaloneMode = () => {
  if ((window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://')) {
    return true;
  } else {
    return false
  }
}

// 判断返回游戏链接是否有参数
export function hasQueryParams(url) {
  const [beforeHash] = url.split("#");
  return beforeHash.includes("?");
}

//获取所有url参数
export function GetUrlParam() {
  let url = document.location.toString();
  let arrObj = url.split("?");
  let params = Object.create(null)
  if (arrObj.length > 1) {
    arrObj = arrObj[1].split("&");
    arrObj.forEach(item => {
      item = item.split("=");
      params[item[0]] = item[1]
    })
  }
  return params;
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 判断机型
export const detectDevice = () => {
  const ua = navigator.userAgent.toLowerCase();

  // 🔥 1. 优先判断Windows桌面系统（新添加！）
  if (/windows|win/i.test(ua)) {
    return 3;
  }

  // 🌐 2. 判断HarmonyOS（鸿蒙系统，优先级第二高）
  if (/openharmony/i.test(ua)) {
    return 7;
  }

  // 🍎 3. 判断iOS（iPhone/iPad/iPod）
  if (/iphone|ipad|iPod/i.test(ua) && !window.MSStream) {
    return 1;
  }

  // 📱 4. 判断Android（手机系统）
  if (/android/i.test(ua)) {
    // if (/xiaomi|mi|redmi/i.test(ua)) {
    //   return "Android (Xiaomi)";
    // } else if (/samsung/i.test(ua)) {
    //   return "Android (Samsung)";
    // } else if (/oppo|oxygen/i.test(ua)) {
    //   return "Android (OPPO)";
    // } else if (/vivo|vivo/i.test(ua)) {
    //   return "Android (VIVO)";
    // } else if (/huawei|honor/i.test(ua)) {
    //   return "Android (Huawei/Honor)";
    // } else {
    //   return "Android (vue)";
    // }
    return 2;
  }

  // 🤷 5. 其他系统（如MacOS、Linux等）
  if (/macintosh|mac os/i.test(ua)) {
    return 8;
  }
  if (/linux/i.test(ua)) {
    return 10;
  }

  return 11;
}
